import { render } from "./RatingBarRank3.vue?vue&type=template&id=7450b1ee&scoped=true"
const script = {}

import "./RatingBarRank3.vue?vue&type=style&index=0&id=7450b1ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7450b1ee"]])

export default __exports__